var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top_header_box"},[_c('img',{attrs:{"src":_vm.headerLogo,"alt":""}}),_c('div',{staticClass:"line_box"},[_c('p',[_c('img',{attrs:{"src":require("@/assets/report2_imgs/icon_fc.png"),"alt":""}}),_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }